<script lang="ts">
  import type { StatusDefinition } from "@kontextwerk/web-sdk/core/display/status"
  import { buildScheduleEventCommunicationTagPresentation } from "../../../../../../../_shared/_logic/communication-presentation"
  import { buildAppointmentHistoryItem } from "../../../../../_shared/_logic/appointment-history"
  import WorkOrderAppointmentTag from "../../../../../_shared/_modules/work-order-appointment-tag"
  import { buildCancelReplanAppointmentTag } from "../../_logic/cancel-replan-presentation"
  import type { CancelReplanRow } from "../../_logic/cancel-replan-contract"

  let {
    row = null,
    event = null,
    preferEventStatus = false,
  }: {
    row?: CancelReplanRow | null
    event?: ScheduleEvent | null
    preferEventStatus?: boolean
  } = $props()

  const relevantEvent = $derived(event ?? row?.event ?? null)
  const tag = $derived(buildCancelReplanAppointmentTag(relevantEvent))
  const eventHistoryItem = $derived(
    preferEventStatus && relevantEvent ? buildAppointmentHistoryItem(relevantEvent) : null,
  )
  const fallbackStatus = $derived(
    tag && relevantEvent?.status
      ? {
          ...buildScheduleEventCommunicationTagPresentation({
            status: relevantEvent.status,
            event: relevantEvent,
          }).definition,
          label: tag.label,
        }
      : null,
  )
  const status = $derived(
    preferEventStatus
      ? (eventHistoryItem?.status ?? fallbackStatus)
      : (row?.workOrderRow?.appointmentStatusDefinition ?? fallbackStatus),
  )
  const subLabel = $derived(
    preferEventStatus
      ? (eventHistoryItem?.subLabel ?? relevantEvent?.employee_name ?? null)
      : (row?.workOrderRow?.appointmentSubLabel ?? relevantEvent?.employee_name ?? null),
  )
  const tooltipContent = $derived(
    preferEventStatus
      ? (eventHistoryItem?.tooltip ?? tag?.tooltipDescription ?? tag?.scheduledPeriodLabel ?? null)
      : (row?.workOrderRow?.statusDescription ??
          tag?.tooltipDescription ??
          tag?.scheduledPeriodLabel ??
          null),
  )
</script>

{#if status}
  <WorkOrderAppointmentTag
    {status}
    subLabel={subLabel ?? undefined}
    tooltipContent={tooltipContent ?? undefined}
  />
{:else}
  {tag?.label ?? "—"}
{/if}
